import { useState } from 'react';
import { api, PanelHowTo } from './_barrel.js';


        // Address exposure — addresses published in the subject's Companies
        // House filings, residential-looking ones flagged (doxxing vector).
        // Reads /api/v1/subjects/{id}/address-exposure (fetched by the parent).
        function AddressExposurePanel({ addresses }) {
            const list = addresses || [];
            const [open, setOpen] = useState(false);
            const residential = list.filter(a => a.looks_residential);
            return (
                <div className="panel mb-6">
                    <div className="panel-header is-self-collapse flex justify-between items-center cursor-pointer" onClick={() => setOpen(!open)}>
                        <div className="font-display text-xl gold">Address Exposure</div>
                        <div className="flex items-center gap-3">
                            <div className="text-xs text-muted font-mono">
                                {list.length ? `${list.length} address${list.length !== 1 ? 'es' : ''}${residential.length ? ` · ${residential.length} residential-looking` : ''}` : 'from Companies House filings'}
                            </div>
                            <div className="text-xs text-muted">{open ? '▾' : '▸'}</div>
                        </div>
                    </div>
                    <PanelHowTo id="address" />
                    {open && (list.length === 0 ? (
                        <div className="px-6 py-8 text-muted text-sm">No addresses published in Companies House filings for this subject.</div>
                    ) : (
                        <div className="px-6 py-5">
                            <div className="text-xs text-muted mb-4" style={{ lineHeight: 1.6 }}>
                                Addresses published in Companies House filings are public. A residential or correspondence home address here is an address-trace / doxxing vector worth advising the subject on. Residential-looking matches are a heuristic — verify before acting.
                            </div>
                            {list.map((a, i) => (
                                <div key={i} className="table-row px-4 py-3" style={a.looks_residential ? { borderLeft: '3px solid var(--amber)' } : {}}>
                                    <div className="flex justify-between items-start gap-4">
                                        <div className="flex-1 min-w-0">
                                            <div className="text-sm">{a.address}</div>
                                            <div className="text-xs text-muted font-mono mt-1">on {a.count} filing{a.count !== 1 ? 's' : ''}{a.companies && a.companies.length ? ` · ${a.companies.join(', ')}` : ''}</div>
                                        </div>
                                        {a.looks_residential && <span className="font-mono text-xs" style={{ color: 'var(--amber)' }}>⚑ POSSIBLE HOME</span>}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            );
        }

export { AddressExposurePanel };
